import { CloudActions } from 'reactApp/constants/cloudActions';

import { APICallV2Get } from './APICall';

export class TrashbinListApiCall extends APICallV2Get {
    _method = 'trashbin';
    _headers = { 'X-VFS-Action': CloudActions.TRASHBIN_VIEW };
}
